import React from "react";
import "./SemiHeader.css";
import { BackIcon, IconMenu } from "assets/SVGs/SVGs";
import { useHistory } from "react-router-dom";
import { ROUTES_CONSTANTS } from "routes/route-constants";

const SemiHeader = (props) => {
  const history = useHistory();
  const { text, isBackHide, show, setShow, primaryColor = true, onBackClick } = props;

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
      return;
    }
    const isLogin = history?.location?.pathname === ROUTES_CONSTANTS?.login;
    if (isLogin) {
      history.push(ROUTES_CONSTANTS?.landingScreen);
    } else {
      history.goBack();
    }
  };

  const handleMenuClick = () => setShow(!show);

  const pathName = history?.location?.pathname;
  return (
    <div className={`sh_container ${!primaryColor ? "layout_black_bg" : ""}`}>
      {!isBackHide ? (
        pathName === ROUTES_CONSTANTS?.customerLogin ? (
          <IconMenu
            width={"20"}
            className={"sh_backIcon"}
            onClick={handleMenuClick}
          />
        ) : (
          <BackIcon
            height={"20"}
            className={"sh_backIcon"}
            onClick={handleBackClick}
          />
        )
      ) : null}
      <h3 className="sh_title display_h3">{text}</h3>
    </div>
  );
};

export default SemiHeader;
